'use strict';

import corteExcepcional from './corteExcepcional.component'

const CorteExcepcionalModule = angular
  .module('app.corteExcepcional', [])
  .component('corteExcepcional', corteExcepcional)
  .config(($stateProvider, $urlRouterProvider) => {
    $stateProvider
      .state('corteExcepcional', {
        url: '/soporte_corte_excepcional',
        component: 'corteExcepcional'
      });
    $urlRouterProvider.otherwise('/');
  })
  .name;

export default CorteExcepcionalModule



// WEBPACK FOOTER //
// ./src/app/components/soporte/corteExcepcional/corteExcepcional.module.js